import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-case-request-detail-files',
  templateUrl: './case-request-detail-files.component.html',
  styleUrls: ['./case-request-detail-files.component.css']
})
export class CaseRequestDetailFilesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
